/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ClaimLeverageGetAccruedInterestOptions,
  ClaimLeverageGetAccruedInterestResponses,
} from '../types/ClaimLeverageGetAccruedInterest'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Claim current accrued leverage interest for a specific user
 * {@link /v1/leverage/accrued_interest/claim}
 */
export function claimLeverageGetAccruedInterest<ThrowOnError extends boolean = true>(
  options: Options<ClaimLeverageGetAccruedInterestOptions, ThrowOnError>,
): Unwrappable<RequestResult<ClaimLeverageGetAccruedInterestResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/leverage/accrued_interest/claim',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ClaimLeverageGetAccruedInterestResponses, ThrowOnError>>,
  )
}
